<template>
    <div class="border rounded p-3" style="background: #F6F9FD" v-if="project && unit">
        <div class="border-bottom pb-3">
            <p class="font-weight-600">{{ customer.name }}</p>
            <p>{{ customer.nric }}</p>
        </div>
        <div class="border-bottom py-3">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <p class="font-weight-500">Property Info</p>
                <div class="d-flex align-items-center text-primary cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="currentColor" d="M0 128c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm559.1-28.2c10.4 5.6 16.9 16.4 16.9 28.2v256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64l-14.2-9.5V174.9l14.2-9.5l96-64c9.8-6.5 22.4-7.2 32.9-1.6"/></svg>
                    <span class="pl-1">Virtual Tour</span>
                </div>
            </div>
            <b-row>
                <b-col cols="12" md="6" class="mb-2">
                    <div class="d-flex align-items-center">
                        <span class="text-muted mr-2">Unit Price</span>
                        <div class="d-flex align-items-center text-success">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 448 512"><path fill="currentColor" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                            <span class="text-xs text-success ml-1">Match</span>
                        </div>
                    </div>
                    <p class="font-weight-600">RM {{ unit.unit_price  | moneyFormatter }}</p>
                </b-col>
                <b-col cols="12" md="6" class="mb-2">
                    <span class="text-muted">Unit Name</span>
                    <p class="font-weight-600">Unit {{ unit.unit_no }}</p>
                </b-col>
                <b-col cols="12" md="6" class="mb-2">
                    <span class="text-muted">Built Up</span>
                    <p class="font-weight-600">{{ unit.built_up }} sqft</p>
                </b-col>
                <b-col cols="12" md="6" class="mb-2">
                    <span class="text-muted">Unit Level</span>
                    <p class="font-weight-600">Level {{ unit.floor_sort === 0 ? 'G' : unit.floor_sort }}</p>
                </b-col>
                <b-col cols="12" md="6" class="mb-2">
                    <span class="text-muted">Property Type</span>
                    <p class="font-weight-600">{{ project.project_type }}</p>
                </b-col>
                <b-col cols="12" md="6" class="mb-2">
                    <span class="text-muted">Lease Type</span>
                    <p class="font-weight-600">{{ project.project_lease_type_id === 1 ? 'Freehold' : 'Leasehold' }}</p>
                </b-col>
                <b-col cols="12" md="6" class="mb-2" v-if="unit.unit_type">
                    <span class="text-muted">No. of Rooms</span>
                    <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center  mr-2">
                            <span class="pr-1 text-xs">{{ unit.unit_type.bedroom }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M2 19v-6q0-.675.275-1.225T3 10.8V8q0-1.25.875-2.125T6 5h4q.575 0 1.075.213T12 5.8q.425-.375.925-.587T14 5h4q1.25 0 2.125.875T21 8v2.8q.45.425.725.975T22 13v6h-2v-2H4v2zm11-9h6V8q0-.425-.288-.712T18 7h-4q-.425 0-.712.288T13 8zm-8 0h6V8q0-.425-.288-.712T10 7H6q-.425 0-.712.288T5 8z"/></svg>
                        </div>
                        <div class="d-flex align-items-center mr-2">
                            <span class="pr-1 text-xs">{{ unit.unit_type.bathroom }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M96 77.3C96 70 101.9 64 109.3 64c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9c-3.6 9-5.6 18.9-5.6 29.2 0 19.9 7.2 38 19.2 52-5.3 9.2-4 21.1 3.8 29 9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5l-14.9-14.9C149.4 8.1 129.7 0 109.3 0 66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H96zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h256v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-40.4c19.6-17.6 32-43.1 32-71.6v-16z"/></svg>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="pr-1 text-xs">{{ unit.unit_type.car_park }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M135.2 117.4 109.1 192h293.8l-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4H165.4c-13.6 0-25.7 8.6-30.2 21.4m-95.6 79.4L74.8 96.3C88.3 57.8 124.6 32 165.4 32h181.2c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-48H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-26.7 16.4-49.6 39.6-59.2M128 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0m288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64"/></svg>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="6" class="mb-2" v-if="project.project_source_type === 'HESTIA'">
                    <span class="text-muted">Booking Fee</span>
                    <p class="font-weight-600">RM {{ unit.fees_booking_amount | moneyFormatter }}</p>
                </b-col>
                <b-col cols="12" class="mt-3" v-if="project.Property_Feature.length > 0">
                    <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="16" viewBox="0 0 512 512"><path fill="#73839C" d="M320 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0m-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5l11-99.5h1.8c17.7 0 32-14.3 32-32v-48c0-35.3-28.7-64-64-64zm-91.7 234.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45 14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4 13.7-8.9 29.1-23.6 29.1-45 0-13.5-6.4-24.5-14-32.6-7.5-7.9-17.3-14.3-27.8-19.6-21-10.6-49.5-18.9-82-24.8-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5 3.2 1.6 5.8 3.1 7.9 4.5 3.6 2.4 3.6 7.2 0 9.6-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3-3.6-2.4-3.6-7.2 0-9.6 2.1-1.4 4.8-2.9 7.9-4.5 15.3-7.7 38.8-14.9 69-20.5z"/></svg>
                    <span class="text-muted">Facing View / Facilities</span>
                    <div class="d-flex align-items-center">
                        <div v-if="project.project_source_type === 'HESTIA'">
                            <span v-for="(feature, index) in project.Property_Feature" :key="index">
                                {{ feature }}<span v-if="index < project.Property_Feature.length - 1">, </span>
                            </span>
                        </div>
                        <div v-else>
                            <span v-for="(feature, index) in project.Property_Feature" :key="index">
                                <p v-html="formatFeature(feature)"></p>
                            </span>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div class="pt-3" v-if="project.project_banks">
            <b-row>
                <b-col cols="12" class="mb-2">
                    <p class="text-muted">Panel Bank</p>
                    <div v-if="project.project_source_type === 'HESTIA'">
                        <span class="font-weight-600" v-for="(bank, index) in project.project_banks" :key="index">
                            {{ bank.bank_detail.name }} <span v-if="index < project.project_banks.length - 1"> | </span>
                        </span>
                    </div>
                    <div v-else>
                        <span class="font-weight-600" v-for="(bank, index) in project.project_banks" :key="index">
                            {{ bank.bank_name }} <span v-if="index < project.project_banks.length - 1"> | </span>
                        </span>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { Switch, Button } from 'element-ui'

export default {
    props: ['project', 'unit', 'customer'],
    components: {
        [Switch.name]: Switch,
        [Button.name]: Button,
    },
    data() {
        return {
            request_rebate: {
                status: false,
                amount: ''
            },
        }
    },
    watch: {
        project: {
            handler(newVal) {
                this.processFeatures()
            },
        },
    },
    methods: {
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
         processFeatures(){
            if (typeof this.project.Property_Feature === 'string') {
                let property_feature_array = this.project.Property_Feature.split(",").map(feature => feature.trim());
                this.project.Property_Feature = property_feature_array;
            } else {
                this.project.Property_Feature = [];
            }
        },
        formatFeature(feature) {
            return feature.replace(/\n/g, ', ');
        }
    }
}
</script>